var _rect, _text, _text2, _circle, _text3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAtomicLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 50,
    viewBox: "0 0 220 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 7,
    width: 36,
    height: 36,
    rx: 8,
    fill: "#FF6B35"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 23,
    y: 33,
    fontFamily: "Arial, sans-serif",
    fontSize: 26,
    fontWeight: 900,
    fill: "#1A1A1A",
    textAnchor: "middle"
  }, "A")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 52,
    y: 33,
    fontFamily: "Arial, sans-serif",
    fontSize: 22,
    fontWeight: 700,
    fill: "#FFFFFF",
    letterSpacing: 0.5
  }, "Atomic")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 138,
    cy: 31,
    r: 2.5,
    fill: "#FF6B35"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 145,
    y: 33,
    fontFamily: "Arial, sans-serif",
    fontSize: 22,
    fontWeight: 700,
    fill: "#FF6B35",
    letterSpacing: 0.5
  }, "Digital")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtomicLogo);
export default __webpack_public_path__ + "static/media/atomic-logo.554e3352ba907561ed3feaddd3c25f08.svg";
export { ForwardRef as ReactComponent };